const state = {
 reload_assignments: false,
 
 assignment: {
  company_id: null,
  order_job_id: null,
 },
 all_assignment: {
  company_id: null,
  order_job_id: null
 }
};

const actions = {};

const mutations = {
 RELOAD_ASSIGNMENTS(state, payload) {
  state.reload_assignments = payload.action;
 },
 
 SET_ORDER_ASSIGNMENT(state, payload) {
  state.assignment.company_id = payload.company_id;
  state.assignment.order_job_id = payload.order_job_id
 },
 SET_ORDER_ASSIGN_ALL(state, payload) {
  state.all_assignment.company_id = payload.company_id
  state.all_assignment.order_job_id = payload.order_job_id,
  state.all_assignment.order_job = payload.order_job
 },
 
 CLEAR_ORDER_ASSIGNMENT(state) {
  state.assignment = {
   company_id: null,
   order_job_id: null,
  }
 },
 CLEAR_ORDER_ASSIGN_ALL(state) {
  state.all_assignment = {
   company_id: null,
   order_job_id: null,
   order_job: null,
  }
 }
};
export default {
 state,
 actions,
 mutations
}
